import React from 'react';
import renderHTML from 'react-render-html';
import { executeGetDoc } from '../../simbix/executer'

class DocCard extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        const {id} = props;
        this.state = {
            loading: false, 			//Флаг загрузки
            properties: undefined,
            id: id,
        }
    }
    
    componentWillMount() { 
        this.loadDoc();
    }

    loadDoc () {
        this.setState({loading: true})
        const {id} = this.state
        return executeGetDoc({id})
            .then ((response) =>{
                //console.log("executeGetDoc({id})", id, response)
                const {properties} = response
                this.setState({loading: false, properties});
                return Promise.resolve(response)
            })
            .catch(e => { 
                return Promise.reject(e);
            });
    }


    render() {
        //Метоописание данных
        const {docs} = this.props;
        //Данные
        const {loading, properties } = this.state;
        const keys = (properties)?Object.keys(properties).filter(key => !["FilePDF", "FileWord"].includes(key)): [];
        console.log(this, keys)
        return (
            (loading? <div>Загрузка</div>:
<table className="doccard-table">
    <tbody>
        <tr>
            <th className="section-header" colspan="2">Содержание</th>
        </tr>
        <tr><td className="dc-text-col88">
            <div className="doccard-abstract">{renderHTML(properties.Abstract)}
            </div><br />
            <span className="uri-field">
                <b>URI:</b>&nbsp;
                <span title={properties.Title} data-uri={properties.URI} className="card-link node-cell">
                    <span class="node-info ui-icon ui-icon-script"></span>
                    <span class="node-info node-uri">{properties.URI}</span>
                </span>
            </span><br/>
            </td>
            <td className="dc-text-col12 icon-links">
                {(properties.FilePDF)?<a target="_blank" href={properties.FilePDF.path}><span className="ico dl-file dl-pdf" style={{display:"inline"}}></span></a>: null}
                {(properties.FileWord)?<a target="_blank" href={properties.FileWord.path}><span className="ico dl-file dl-doc" style={{display:"inline"}}></span></a>:null}
                <a style={{display:"none"}} target="_blank" href="/docs/document/1143.1142.htm"><span className="ico dl-file dl-htm" style={{display:"inline"}}></span></a>
            </td>
        </tr>
    </tbody>
</table>
)
        )
    }
}

export default DocCard;